import { render, staticRenderFns } from "./PosInvoicesTaxAdd.vue?vue&type=template&id=2675cac5&scoped=true&"
import script from "./PosInvoicesTaxAdd.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675cac5",
  null
  
)

export default component.exports